import { createValidator } from "@/scripts/components/form/validation/validator";
import { fireEvent, trackGoogleAnalytics } from "@/scripts/common/util";
import { showFormMessages } from "@/scripts/components/form/form";
import ajax from "@/scripts/common/ajax";
import "./donation-form.css";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";

const stripe = window.Stripe(document.querySelector(".donation-form").dataset.stripeKey);

let elements;

const handlePaymentForm = async (form) => {
  const intentId = form.querySelector('[name="StripeIntentID"]');
  const customerId = form.querySelector('[name="StripeCustomerID"]');

  const appearance = {
    labels: "floating",
    theme: "stripe",
    variables: {
      colorPrimary: "#eb532a",
      colorBackground: "#ffffff",
      colorDanger: "#b5134b",
      fontFamily: "Gotham, system-ui, sans-serif",
      fontWeightMedium: "500",
      fontWeightBold: "500",
      borderRadius: "8px",
    },
  };

  const submitButton = form.querySelector('[type="submit"]');
  submitButton.disabled = true;

  try {
    const paymentEndpoint = form.dataset.paymentEndpoint;

    const data = new FormData(form);

    const res = await ajax.post(paymentEndpoint, { body: data }).json();

    if (intentId.value) {
      elements.fetchUpdates();
    } else {
      elements = stripe.elements({ clientSecret: res.clientSecret, appearance });

      const paymentElement = elements.create("payment", {
        layout: "tabs",
      });

      paymentElement.mount("#payment-element");
    }

    intentId.value = res.intentId;
    customerId.value = res.customerId;
  } catch (error) {
    console.error(error);
  } finally {
    submitButton.disabled = false;
  }
};

const handlePaymentSubmit = async (e) => {
  e.preventDefault();

  const form = e.currentTarget;
  const submitButton = form.querySelector('[type="submit"]');
  const formData = new FormData(form);

  submitButton.disabled = true;
  submitButton.classList.add("is-loading");

  const { error } = await stripe.confirmSetup({
    elements,
    confirmParams: {
      return_url: "https://rcil.com",
    },
    redirect: "if_required",
  });

  if (error && (error.type === "card_error" || error.type === "validation_error")) {
    showMessage(error.message);
    submitButton.disabled = false;
    submitButton.classList.remove("is-loading");
  } else {
    try {
      const res = await ajax.post(form.action, { body: formData }).json();

      if (res.success) {
        if (res.ga) {
          res.ga.forEach((event) => trackGoogleAnalytics(event));
        }

        form.querySelectorAll("fieldset").forEach((x) => x.remove());

        fireEvent("form:submit", form);
      }

      if (res.messages) {
        showFormMessages(form, res.messages, true, false);
      }
    } catch (error) {
      console.error(error);
      showMessage("An unexpected error occurred.");
      submitButton.disabled = false;
      submitButton.classList.remove("is-loading");
    }
  }
};

function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageContainer.textContent = "";
  }, 4000);
}

document.addEventListener("DOMContentLoaded", () => {
  const holder = document.getElementById("donate-form");
  const form = document.querySelector(".donation-form");

  document.documentElement.addEventListener("form:payment-step", () => {
    handlePaymentForm(form);
  });

  form.addEventListener("submit", handlePaymentSubmit);

  form.querySelectorAll(".form-step-submit").forEach((submit) => {
    submit.addEventListener("click", () => {
      if (submit.dataset.stepDir === "next") {
        const validator = createValidator(form);
        const result = validator.validateForm();

        if (!result.isValid) {
          return false;
        }
      }

      if (holder) {
        scrollToIfNeeded(holder, 24);
      }

      fireEvent("donation-form:step", document.documentElement, { step: submit.dataset.step });
    });
  });
});
